import {reactFetchJSON, type JSONRequestInit} from '@github-ui/verified-fetch'
import {buildItemPickersBulkActionsUrl} from '@github-ui/item-picker-base/api/urls'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import type {BulkActionQueryTarget} from '@github-ui/item-picker-base/ItemPicker'
import {UpdateIssuesBulk, UpdateIssuesBulkByQuery} from '@github-ui/server-persisted-queries'
import type {UpdateIssuesBulkMutation} from '@github-ui/server-persisted-queries/types/UpdateIssuesBulk'
import type {UpdateIssuesBulkByQueryMutation} from '@github-ui/server-persisted-queries/types/UpdateIssuesBulkByQuery'

export type UpdateIssueLabelsBulkRequest = {
  ids: string[]
  queryTarget?: BulkActionQueryTarget
  addedLabelIds: string[]
  removedLabelIds: string[]
}

export type UpdateIssueLabelsBulkResponse = GraphQLResponse<
  Partial<UpdateIssuesBulkMutation & UpdateIssuesBulkByQueryMutation>
>

export async function apiUpdateIssueLabelsBulk(
  request: UpdateIssueLabelsBulkRequest,
): Promise<UpdateIssueLabelsBulkResponse> {
  const requestUrl = buildItemPickersBulkActionsUrl()
  const body: Record<string, unknown> = {
    ...(request.queryTarget ?? {ids: request.ids}),
    addedLabelIds: request.addedLabelIds,
    removedLabelIds: request.removedLabelIds,
    queryId: request.queryTarget ? UpdateIssuesBulkByQuery : UpdateIssuesBulk,
  }

  const init: JSONRequestInit = {
    method: 'POST',
    body,
  }
  const response = await reactFetchJSON(requestUrl, init)
  return response.json() as Promise<UpdateIssueLabelsBulkResponse>
}
